import React from 'react';
import { AppToastViewport } from './AppToastViewport';

interface AppToastProviderProps {
  children: React.ReactNode;
}

/**
 * Mounts the toast layer once at app root. The viewport renders inline at
 * the bottom of the screen via absolute positioning — no portal, no
 * separate React tree, so theme tokens from the surrounding
 * `<TamaguiProvider><Theme>` chain propagate normally.
 *
 * Toast state lives in a Zustand store (see `toast-store.ts`); the public
 * API (`useAppToast()`) is unchanged from the previous `@tamagui/toast`
 * implementation, so consumers don't need to update.
 */
export function AppToastProvider({ children }: AppToastProviderProps) {
  return (
    <>
      {children}
      <AppToastViewport />
    </>
  );
}
